import { Skeleton } from '@mui/material'

export function UserSkeleton() {
  return (
    <div className='flex w-full flex-col items-center justify-center'>
      <div className='flex w-[80%] flex-col gap-y-5'>
        <div className='flex w-full gap-4'>
          <Skeleton
            variant='circular'
            height={60}
            width={60}
            sx={{ minWidth: '60px' }}
            animation='pulse'
          />
          <Skeleton variant='rounded' height={60} sx={{ width: '100%' }} animation='pulse' />
        </div>
        <div className='flex gap-4'>
          <Skeleton
            variant='circular'
            height={60}
            width={60}
            sx={{ minWidth: '60px' }}
            animation='pulse'
          />
          <Skeleton variant='rounded' height={60} sx={{ width: '100%' }} animation='pulse' />
        </div>
        <div className='flex gap-4'>
          <Skeleton
            variant='circular'
            height={60}
            width={60}
            animation='pulse'
            sx={{ minWidth: '60px' }}
          />
          <Skeleton variant='rounded' height={60} sx={{ width: '100%' }} animation='pulse' />
        </div>
      </div>
    </div>
  )
}
